/**
 * Created by dinesh on 13/6/17.
 */
import {Component} from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';
import {KeyValue} from '../key-value';
import {AuthorizationService} from '../authorization.service';

@Component({
  selector: 'app-shared-signout',
  templateUrl: 'sign-out.component.html'
})
export class SignOutComponent {
  constructor(private router: Router, private _tokenService: AngularTokenService,
              private authService: AuthorizationService  ) {
  }
  signout(): void {
    // console.log('signou called');
    const excludeList1 = [
      '/student/control/security-decisions',
      '/student/control/loan-decisions',
      '/student/control/deposits-decisions',
      '/student/control/treasury-decision'
    ];
    const loc1 = window.location.pathname
    // console.log('loc1 :'+loc1);
    if(!excludeList1.includes(loc1)){
      document.getElementById('logoutpop').click();
    } else {
      this.authService.logoutFromDeactivate = true;
      this.router.navigate([KeyValue.signinPath]);
    }
  }

  kickOut(): void {
    this.authService.logoutTimerStarted = false;
    localStorage.removeItem('currentUserData');
    this.authService.logout();
  }

  saveYes(): void {
    const hiddenInput = document.createElement("input");
      hiddenInput.setAttribute("id", "uniqueIdentifier");
      hiddenInput.setAttribute("value", 'Logout');
      if(document.getElementById("security-decision-form")){
      document.getElementById("security-decision-form").appendChild(hiddenInput)
    }
     if(document.getElementById("loan-decision-form")){
     document.getElementById("loan-decision-form").appendChild(hiddenInput)
   }
   if(document.getElementById("deposit-decision-form")){
   document.getElementById("deposit-decision-form").appendChild(hiddenInput)
 }
 if(document.getElementById("treasury-decision-form")){
 document.getElementById("treasury-decision-form").appendChild(hiddenInput)
}
    const excludeList = ['file_upload'];
    [].forEach.call(document.querySelectorAll('[type=submit]'), function (el) {
      if(!excludeList.includes(el.id)){
        try {el.click()}catch(e){
          console.log('error' +e);
        }
      }
    });
    document.getElementById('logoutpop').click();
    const that = this;
    setTimeout(function(){
        that.kickOut();
    },1000);
    console.log('save yes')
  }

  saveNo(): void {
    console.log('save No')
    document.getElementById('logoutpop').click();
    this.kickOut();
  }
}
